import AtomicBlockIdentifiers from "../AtomicBlockIdentifiers";

/**
 * @param   {ContentState} contentState
 * @returns {?String}
 */
export default function getReadTime(contentState) {
  let wordsCount = 0;
  let imagesCount = 0;

  contentState.getBlocksAsArray().forEach(block => {
    if (
      block.getType() === "atomic" &&
      block.getData().get("blockType") === AtomicBlockIdentifiers.IMAGE
    ) {
      imagesCount += 1;
    } else if (block.getText()) {
      const words = block
        .getText()
        .split(" ")
        .filter(word => word.trim());

      wordsCount += words.length;
    }
  });

  if (wordsCount > 0 || imagesCount > 0) {
    // 275 words per minute
    let textReadTime = wordsCount / 275 * 60;
    let imagesReadTime = 0;

    for (let i = 0, l = imagesCount; i < l; i += 1) {
      imagesReadTime += Math.max(12 - i, 3);
    }

    return Math.round(textReadTime + imagesReadTime);
  }

  return null;
}
